var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('english-interview-list-component',{attrs:{"ui":_vm.ui,"routeToDetails":_vm.detailsRoute}})}
var staticRenderFns = []

export { render, staticRenderFns }